import { defineComponent as _defineComponent } from 'vue'
import VueCountdown from '@chenfengyuan/vue-countdown';
import { computed, toRefs, useContext } from '@nuxtjs/composition-api';
import type { SlotProps } from '~/core/types/affility/components/countdown/SlotProps';
import type { Unit } from '~/core/types/affility/components/countdown/Unit';
import type { SlotPropsTransform } from '~/core/types/affility/components/countdown/SlotPropsTransform';
import type { Now } from '~/core/types/affility/components/countdown/Now';

interface Props {
    time: string | number | Date,
    theme?: 'light' | 'dark',
    units?: Unit[],
    size?: 'l' | 'm',
    closeTime?: number,
    tag?: string,
    autoStart?: boolean,
    emitEvents?: boolean,
    interval?: number,
    now?: Now,
    transform?: SlotPropsTransform,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Simple',
  props: {
    time: null,
    theme: null,
    units: null,
    size: { default: 'm' },
    closeTime: null,
    tag: null,
    autoStart: { type: Boolean, default: true },
    emitEvents: { type: Boolean, default: true },
    interval: null,
    now: null,
    transform: { default: () => (time: SlotProps) => {
        for (const key in time) {
            if (time[key] < 10) {
                time[key] = `0${time[key]}`;
            }
        }
        return time;
    } }
  },
  emits: ['start', 'end', 'progress', 'abort'],
  setup(__props: any) {

const props = __props as { time: string | number | Date, theme?: 'light' | 'dark', units?: Unit[], size: 'l' | 'm', closeTime?: number, tag?: string, autoStart: boolean, emitEvents: boolean, interval?: number, now?: Now, transform: SlotPropsTransform };





const {
    time,
    theme,
    units,
    size,
    closeTime,
    tag,
    autoStart,
    emitEvents,
    interval,
    now,
    transform,
} = toRefs(props);

const { i18n } = useContext();

const computedUnits = computed(() => units.value || [
    {
        slotProp: 'days',
        title: i18n.t('Days'),
    },
    {
        slotProp: 'hours',
        title: i18n.t('Hrs'),
    },
    {
        slotProp: 'minutes',
        title: i18n.t('Mins'),
    },
    {
        slotProp: 'seconds',
        title: i18n.t('Secs'),
    },
] as Unit[]);

const endMs = computed(() => Math.max((new Date(time.value).getTime() - Date.now()) || 0, 0));

const areAllPreviousAndCurrentUnitsZero = (slotData: SlotProps, currentUnit: Unit) => {
    for (const unit of computedUnits.value) {
        if (Number(slotData[unit.slotProp])) {
            return false;
        }
        if (unit === currentUnit) {
            return true;
        }
    }
    return true;
};

const isEnded = (slotData: SlotProps) => {
    for (const unit of computedUnits.value) {
        if(Number(slotData[unit.slotProp])) {
            return false;
        }
    }
    return true;
};


return { __sfc: true,props, time, theme, units, size, closeTime, tag, autoStart, emitEvents, interval, now, transform, i18n, computedUnits, endMs, areAllPreviousAndCurrentUnitsZero, isEnded, VueCountdown }
}

})